import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const LocationIcon: FC<IconProps> = memo(
  ({ width, height, size, color = '#19CAB5', style }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 26 28"
        fill="none"
        style={style}
      >
        <Path
          d="M13 28C11.1944 28 0 19.5587 0 12.6C0 5.6413 5.82039 0 13 0C20.1796 0 26 5.6413 26 12.6C26 19.5587 14.8056 28 13 28ZM13 16.45C15.1938 16.45 16.9722 14.7262 16.9722 12.6C16.9722 10.4738 15.1938 8.75 13 8.75C10.8063 8.75 9.02778 10.4738 9.02778 12.6C9.02778 14.7262 10.8063 16.45 13 16.45Z"
          fill={color}
        />
      </Svg>
    );
  },
);
